module.exports = __webpack_public_path__ + "static/media/fridge.4fb333fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/hundredDaysActivities/record/img/fridge.png
// module id = 346
// module chunks = 0